import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ChevUpActive from "../../../../../Assets/Icons/Admin panel/chev-up-active.svg";
import ChevDownActive from "../../../../../Assets/Icons/Admin panel/chev-down-active.svg";
import ChevUpInctive from "../../../../../Assets/Icons/Admin panel/chev-up-inactive.svg";
import ChevDownInctive from "../../../../../Assets/Icons/Admin panel/chev-down-inactive.svg";
import UserManagementTableRow from "../UI elements/UserManagementTableRow";
import Pagination from "../UI elements/Pagination";
import SimpleDatepicker from "../UI elements/Datepicker";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import NumberInput from "../UI elements/NumberInput";
import Bride from "../../../../../Assets/Images/Lonely bride.svg";
import IOSSwitch from "../UI elements/iOSswitch";
import dayjs from "dayjs";
import axiosInstance from "../../../../../axiosInstance";

const UserManagement = (props) => {
  const [Users, setUsers] = useState([]);
  const [Pages, setPages] = useState([1]);
  const [UserToEdit, setUserToEdit] = useState();
  const [PageInfo, setPageInfo] = useState({
    FirstPage: 1,
    FirstDotsShown: false,
    MiddlePage: 3,
    LastDotsShown: false,
    LastPage: 7,
    ActivePage: 1,
  });
  const [SelectedSize, setSelectedSize] = useState(5);
  const [TotalElements, setTotalElements] = useState(10);
  const [Start, setStart] = useState(0);
  const [ResultIsEmpty, setResultIsEmpty] = useState(false);
  const [SelectedItems, setSelectedItems] = useState([]);
  const [PrevId, setPrevId] = useState("");
  const [SelectedProfiles, setSelectedProfiles] = useState([]);
  const [ActiveSort, setActiveSort] = useState({
    type: "firstName",
    direction: "asc",
  });
  const [EditUserIsOpen, setEditUserIsOpen] = useState(false);
  const [ChangesMade, setChangesMade] = useState(false);
  const [SelectedStart, setSelectedStart] = useState(0);
  const [LoggedinUser, setLoggedinUser] = useState();

  useEffect(() => {
    getFilteredData(1, 5, "firstName,asc", undefined, undefined);
    fetchLoggedinUser();
  }, []);

  useEffect(() => {
    getFilteredData(1, SelectedSize, "firstName,asc");
  }, [props.SelectedFilters]);

  const fetchLoggedinUser = () => {
    let Req = {
      method: "GET",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/account",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        setLoggedinUser(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getFilteredData = (PageNumber, Size, Sort) => {
    // "?page=1&size=5&sort=firstName,asc&search=an&status=ACTIVE&profile=ROLE_USER"
    if (!Size) {
      Size = SelectedSize;
    }

    let ReqURL =
      window.localStorage.getItem("BaseURL") +
      "/api/admin/users?page=" +
      parseInt(PageNumber - 1) +
      "&size=" +
      Size;

    if (
      props.SelectedFilters.keyword &&
      props.SelectedFilters.keyword.length > 0
    ) {
      ReqURL = ReqURL + "&search=" + props.SelectedFilters.keyword;
    }
    if (
      props.SelectedFilters.statuses &&
      props.SelectedFilters.statuses.length > 0
    ) {
      ReqURL =
        ReqURL + "&statuses=" + props.SelectedFilters.statuses.toString();
    }
    if (
      props.SelectedFilters.profiles &&
      props.SelectedFilters.profiles.length > 0
    ) {
      ReqURL =
        ReqURL + "&profiles=" + props.SelectedFilters.profiles.toString();
    }
    if (Sort) {
      ReqURL = ReqURL + "&sort=" + Sort;
    } else {
      if (ActiveSort) {
        ReqURL =
          ReqURL + "&sort=" + ActiveSort.type + "," + ActiveSort.direction;
      }
    }

    setSelectedStart(PageNumber);

    let Req = {
      method: "GET",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setTotalElements(Res.headers["x-total-count"]);
        createPagination(Res.headers["x-total-count"]);

        if (Res.data.length === 0) {
          setResultIsEmpty(true);
        } else {
          setResultIsEmpty(false);
        }

        setTimeout(() => {
          if (PageNumber === 1 && document.getElementById("1-page-btn")) {
            updatePaginationActiveClass(1);
          }
          if (document.getElementById("1-page-btn") && Size !== SelectedSize) {
            document.getElementById("1-page-btn").click();
          }
        }, 500);
        setUsers(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const createPagination = (TotalCount) => {
    let Size = parseInt(SelectedSize);
    let Count = Math.ceil(TotalCount / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    if (document.getElementById(PageNumber + "-page-btn") !== null) {
      if (PageNumber === 3) {
        document.getElementById(3 + "-page-btn").classList.add("active-page");
      } else {
        document
          .getElementById(PageNumber + "-page-btn")
          .classList.add("active-page");
      }
    }
  };

  const toggleEditUser = (User) => {
    let Req = {
      method: "GET",
      baseURL:
        window.localStorage.getItem("BaseURL") + "/api/admin/users/" + User.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setUserToEdit(Res.data);
        setEditUserIsOpen(true);
        props.SetEditUserIsActive(true);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const saveData = () => {
    let Data = { ...UserToEdit };
    if (!UserToEdit.activated) {
      if (UserToEdit.availableCredits) {
        Data.availableCredits = UserToEdit.availableCredits;
      } else if (UserToEdit.availableCredits === null) {
        Data.availableCredits = null;
      } else {
        Data.availableCredits = 0;
      }
    }

    let Req = {
      method: "PUT",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/admin/users",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };

    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setChangesMade(false);
        getFilteredData(1, SelectedSize, "firstName,asc", undefined, undefined);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const setSize = () => {
    setTimeout(async () => {
      if (document.getElementById("1-page-btn") !== null) {
        await setSelectedSize(
          parseInt(
            document.getElementById("pre-selected-row-per-page").innerHTML
          )
        );
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  const saveBirthDate = (NewBirthDate) => {
    setChangesMade(true);
    setUserToEdit({ ...UserToEdit, birthDate: NewBirthDate });
  };
  const handleEmailChange = (e) => {
    setChangesMade(true);
    setUserToEdit({ ...UserToEdit, email: e.target.value });
  };
  const handleNameChange = (e) => {
    setChangesMade(true);
    setUserToEdit({ ...UserToEdit, fullName: e.target.value });
  };
  const handleActivationChange = (e) => {
    setUserToEdit({ ...UserToEdit, activated: e.target.checked });
    setChangesMade(true);
  };
  const handleLockChange = (e) => {
    setUserToEdit({ ...UserToEdit, locked: e.target.checked });
    setChangesMade(true);
  };
  const handleBlockChange = (e) => {
    setUserToEdit({ ...UserToEdit, blocked: e.target.checked });
    setChangesMade(true);
  };
  const handleStatusChange = (event) => {
    setUserToEdit({ ...UserToEdit, assignedProfiles: event.target.value });
    setChangesMade(true);
  };
  const handleCreditsChange = (value) => {
    setUserToEdit({
      ...UserToEdit,
      availableCredits: value,
    });
    setChangesMade(true);
  };
  const handlePaginationSizeChange = (NewSize) => {
    setSelectedSize(NewSize);
    getFilteredData(1, NewSize, "firstName,asc", undefined, undefined);
  };

  const toggleTableHeadSortByName = (RequestedType, Direction) => {
    let NewDirection = "desc";
    if (Direction === "asc") {
      NewDirection = "asc";
    }

    let NewType = "firstName";
    if (RequestedType === "usedCredits") {
      NewType = "usedCredits";
    } else if (RequestedType === "createdDate") {
      NewType = "createdDate";
    } else if (RequestedType === "totalTokenUsed") {
      NewType = "totalTokenUsed";
    }

    setActiveSort({ type: NewType, direction: NewDirection });
    getFilteredData(
      1,
      SelectedSize,
      "&sort=" + RequestedType + "," + Direction
    );
  };

  const deselectCheckboxes = () => {
    // document.getElementById("delete-btn").classList.add("disabled");
    // document.getElementById("checkbox-all").checked = false;
    // for (let i = 0; i < SelectedItems.length; i++) {
    //   document.getElementById("checkbox-" + SelectedItems[i]).checked = false;
    // }
    // setSelectedItems([]);
  };

  const requestPageNumber = (PageNumber) => {
    updatePaginationActiveClass(PageNumber);
    getFilteredData(PageNumber);
    if (PageNumber === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === Pages.length) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
    }
  };

  const updatePaginationActiveClass = (CurrentId) => {
    Pages.map((Page) => {
      if (document.getElementById(Page + "-page-btn")) {
        document
          .getElementById(Page + "-page-btn")
          .classList.remove("active-page");
      }
    });
    document
      .getElementById(CurrentId + "-page-btn")
      .classList.add("active-page");
  };

  const toggleDeleteUser = (UserId) => {
    let Req = {
      method: "DELETE",
      baseURL:
        window.localStorage.getItem("BaseURL") + "/api/admin/users/" + UserId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        getFilteredData(
          1,
          SelectedSize,
          ActiveSort.type === "nameLike"
            ? ActiveSort.type + "," + ActiveSort.direction
            : undefined,
          undefined,
          undefined
        );
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const toggleCancelEdit = () => {
    setEditUserIsOpen(false);
    props.SetEditUserIsActive(false);
    setChangesMade(false);
    getFilteredData(1);
  };

  const isYoungerThan13 = (date) => {
    const today = dayjs();
    const birthDate = dayjs(date);
    const age = today.diff(birthDate, "year");

    if (date === null) {
      return false;
    } else {
      return age < 13;
    }
  };

  const selectSaveBtnClassName = () => {
    if (UserToEdit.activated) {
      if (
        (ChangesMade &&
          !isYoungerThan13(UserToEdit.birthDate) &&
          UserToEdit.availableCredits) ||
        (ChangesMade &&
          !isYoungerThan13(UserToEdit.birthDate) &&
          UserToEdit.availableCredits === 0)
      ) {
        return "action-btn save";
      } else {
        return "action-btn save disabled";
      }
    } else {
      if (ChangesMade && !isYoungerThan13(UserToEdit.birthDate)) {
        return "action-btn save";
      } else {
        return "action-btn save disabled";
      }
    }
  };

  return (
    <div className="form-wrapper">
      <section className="form-head">
        {EditUserIsOpen ? (
          <>
            <i
              onClick={() => toggleCancelEdit()}
              className="feather-arrow-left arrow-back"
            ></i>
            <h1 className="head-title">Back to the user list</h1>
            <section className="head-actions">
              <span
                onClick={() => toggleCancelEdit()}
                className="action-btn cancel"
              >
                <Link>Cancel</Link>
              </span>
              <span
                className={selectSaveBtnClassName()}
                onClick={() => saveData()}
              >
                Save
              </span>
            </section>
          </>
        ) : (
          <>
            {" "}
            <div className="table-filter small"></div>
            <div className="table-filter medium">Username</div>
            <div
              className="table-filter medium name-filter"
              onClick={() =>
                toggleTableHeadSortByName(
                  "firstName",
                  ActiveSort.direction === "asc" ? "desc" : "asc"
                )
              }
            >
              Name
              <span className="filter-arrows">
                <img
                  src={
                    ActiveSort.type === "firstName" &&
                    ActiveSort.direction === "asc"
                      ? ChevUpActive
                      : ChevUpInctive
                  }
                />
                <img
                  src={
                    ActiveSort.type === "firstName" &&
                    ActiveSort.direction === "desc"
                      ? ChevDownActive
                      : ChevDownInctive
                  }
                />
              </span>
            </div>
            <div className="table-filter medium profile-filter">
              Assigned profile
            </div>
            <div
              className="table-filter medium create-date"
              onClick={() =>
                toggleTableHeadSortByName(
                  "createdDate",
                  ActiveSort.direction === "asc" ? "desc" : "asc"
                )
              }
            >
              Created on
              <span className="filter-arrows">
                <img
                  src={
                    ActiveSort.type === "createdDate" &&
                    ActiveSort.direction === "asc"
                      ? ChevUpActive
                      : ChevUpInctive
                  }
                />
                <img
                  src={
                    ActiveSort.type === "createdDate" &&
                    ActiveSort.direction === "desc"
                      ? ChevDownActive
                      : ChevDownInctive
                  }
                />
              </span>
            </div>
            <div
              className="table-filter medium create-date"
              onClick={() =>
                toggleTableHeadSortByName(
                  "usedCredits",
                  ActiveSort.direction === "asc" ? "desc" : "asc"
                )
              }
            >
              Credits used
              <span className="filter-arrows">
                <img
                  src={
                    ActiveSort.type === "usedCredits" &&
                    ActiveSort.direction === "asc"
                      ? ChevUpActive
                      : ChevUpInctive
                  }
                />
                <img
                  src={
                    ActiveSort.type === "usedCredits" &&
                    ActiveSort.direction === "desc"
                      ? ChevDownActive
                      : ChevDownInctive
                  }
                />
              </span>
            </div>
            <div
              className="table-filter medium create-date"
              onClick={() =>
                toggleTableHeadSortByName(
                  "totalTokenUsed",
                  ActiveSort.direction === "asc" ? "desc" : "asc"
                )
              }
            >
              Tokens used
              <span className="filter-arrows">
                <img
                  src={
                    ActiveSort.type === "totalTokenUsed" &&
                    ActiveSort.direction === "asc"
                      ? ChevUpActive
                      : ChevUpInctive
                  }
                />
                <img
                  src={
                    ActiveSort.type === "totalTokenUsed" &&
                    ActiveSort.direction === "desc"
                      ? ChevDownActive
                      : ChevDownInctive
                  }
                />
              </span>
            </div>
            <div className="table-filter medium">Status</div>
          </>
        )}
      </section>

      {EditUserIsOpen ? (
        <div className="table-body">
          <section className="top-section">
            <p className="section-label">Personal Information</p>
            <section className="section-row">
              <p className="row-name">Username</p>
              <TextField
                autoComplete="off" // Disable autofill
                fullWidth
                id="email"
                name="email"
                label={"Email"}
                disabled
                placeholder={""}
                variant="outlined"
                value={UserToEdit.email}
                onChange={handleEmailChange}
                margin="normal"
                sx={{
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "#FB4764", // Change border color when focused
                    },
                  backgroundColor: "transparent",
                  borderRadius: "4px",
                  width: "400px",
                  borderBottom: "none",
                }}
              />
            </section>
            <section className="section-row">
              <p className="row-name">Name</p>
              <TextField
                autoComplete="off" // Disable autofill
                fullWidth
                id="name"
                name="name"
                label={"Name"}
                placeholder={""}
                variant="outlined"
                value={UserToEdit.fullName}
                onChange={handleNameChange}
                margin="normal"
                sx={{
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "#c4c4c4", // Change border color when focused
                    },
                  backgroundColor: "transparent",
                  borderRadius: "4px",
                  width: "400px",
                  borderBottom: "none",
                }}
              />
            </section>
            <section className="section-row">
              <p className="row-name">Birthdate</p>
              <div className="datepicker-wrapper">
                <SimpleDatepicker
                  Label={"Birth date"}
                  MaxDate={dayjs().subtract(13, "year")}
                  DefaultValue={
                    UserToEdit.birthDate ? UserToEdit.birthDate : null
                  }
                  SaveNewDate={(Birthdate) => saveBirthDate(Birthdate)}
                />
                <>
                  {UserToEdit.birthDate !== null ? (
                    <>
                      {isYoungerThan13(UserToEdit.birthDate) ? (
                        <p className="hint error-hint">
                          User must be at least 13 years old!
                        </p>
                      ) : (
                        <p className="hint">MM/DD/YYYY</p>
                      )}
                    </>
                  ) : (
                    <p className="hint">MM/DD/YYYY</p>
                  )}
                </>
              </div>
            </section>
          </section>
          <section className="top-section no-border-bottom">
            <p className="section-label">User Settings</p>
            <section className="section-row">
              <span className="row-name">
                Activation<p className="mandatory">*</p>
                <p className="info">Verified user</p>
              </span>
              <IOSSwitch
                checked={UserToEdit.activated}
                onChange={handleActivationChange}
              />
            </section>
            <section className="section-row">
              <span className="row-name">
                Locked{" "}
                <p className="mandatory" style={{ opacity: "0" }}>
                  *
                </p>
                <p className="info">Unlock a locked user</p>
              </span>
              <IOSSwitch
                checked={UserToEdit.locked}
                onChange={handleLockChange}
              />
            </section>
            <section className="section-row">
              <span className="row-name">
                Block{" "}
                <p className="mandatory" style={{ opacity: "0" }}>
                  *
                </p>
                <p className="info">Block the user permanently</p>
              </span>
              <IOSSwitch
                checked={UserToEdit.blocked}
                onChange={handleBlockChange}
              />
            </section>
            <section className="section-row" style={{ marginTop: "16px" }}>
              <p className="row-name">Account created on</p>
              <div className="datepicker-wrapper">
                <SimpleDatepicker
                  Label={"Created date"}
                  Disabled={true}
                  // MaxDate={dayjs().subtract(13, "year")}
                  DefaultValue={
                    UserToEdit.createdDate ? UserToEdit.createdDate : null
                  }
                  SaveNewDate={(Birthdate) => saveBirthDate(Birthdate)}
                />
                <></>
              </div>
            </section>
            <section className="section-row">
              <p className="row-name">
                Assigned Profile<p className="mandatory">*</p>
              </p>
              <FormControl
                variant="outlined"
                fullWidth
                sx={{ marginTop: "16px" }}
              >
                <InputLabel id="status-label">Profile</InputLabel>
                <Select
                  labelId="status-label"
                  id="status"
                  multiple
                  value={UserToEdit.assignedProfiles}
                  onChange={handleStatusChange}
                  label="Status"
                  inputProps={{ MenuProps: { disableScrollLock: true } }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderColor: "#171717", // Change border color
                    },
                    width: "235px",
                  }}
                >
                  <MenuItem value="ROLE_ADMIN">Admin</MenuItem>
                  <MenuItem value="ROLE_USER">User</MenuItem>
                </Select>
              </FormControl>
            </section>
            <section className="section-row">
              <p className="row-name">Available / Used credits</p>
              <NumberInput
                Label="Available credits"
                Disabled={UserToEdit.activated ? false : true}
                OnChange={(NewValue) => handleCreditsChange(NewValue)}
                Value={parseInt(UserToEdit.availableCredits)}
                Required
              />
              <NumberInput
                Label="Used credits"
                Disabled
                Value={UserToEdit.usedCredits}
              />
            </section>

            <section className="section-row">
              <p className="row-name">Available / Used tokens</p>
              <NumberInput
                Disabled
                type="text"
                Label="Available tokens"
                Value={UserToEdit.availableToken?.toLocaleString("en-US")}
              />
              <NumberInput
                Disabled
                type="text"
                Label="Used tokens"
                Value={UserToEdit.totalTokenUsed?.toLocaleString("en-US")}
              />
            </section>
          </section>
        </div>
      ) : (
        <>
          <div className="table-body">
            {ResultIsEmpty ? (
              <div className="empty-state">
                <img alt="" src={Bride} />
                <h1>No results found</h1>
              </div>
            ) : (
              <>
                {Users.map((Item, i) => (
                  <UserManagementTableRow
                    key={i}
                    Item={Item}
                    LoggedinUser={LoggedinUser}
                    EditUser={() => {
                      toggleEditUser(Item);
                    }}
                    ToggleDeleteUser={(UserId) => toggleDeleteUser(UserId)}
                  />
                ))}
              </>
            )}
          </div>

          {ResultIsEmpty ? null : (
            <Pagination
              Pages={Pages}
              PageInfo={PageInfo}
              SelectedSize={SelectedSize}
              SelectedStart={SelectedStart}
              TotalElements={TotalElements}
              SelectedProfiles={SelectedProfiles}
              DeselectCheckboxes={() => deselectCheckboxes()}
              RequestPageNumber={(PageNum) => requestPageNumber(PageNum)}
              setSelectedSize={(Size) => handlePaginationSizeChange(Size)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default UserManagement;
